/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem
     */
    name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem {
    return DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsEmbOutlineFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


